import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "form-parent" }
const _hoisted_2 = {
  key: 0,
  class: "grey-form-card"
}
const _hoisted_3 = { class: "profile-header" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "el-icon-more" }, null, -1)
const _hoisted_5 = { class: "small-grey" }
const _hoisted_6 = { class: "card-parent" }
const _hoisted_7 = {
  key: 0,
  class: "card-row"
}
const _hoisted_8 = { class: "card-label" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Job Title:")
const _hoisted_10 = { class: "card-value" }
const _hoisted_11 = {
  key: 1,
  class: "card-row"
}
const _hoisted_12 = {
  key: 0,
  class: "card-label"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Email:")
const _hoisted_14 = { class: "card-value" }
const _hoisted_15 = {
  key: 2,
  class: "card-row"
}
const _hoisted_16 = { class: "card-label" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Phone:")
const _hoisted_18 = { class: "card-value" }
const _hoisted_19 = {
  key: 3,
  class: "card-row"
}
const _hoisted_20 = { class: "card-label" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Language:")
const _hoisted_22 = { class: "card-value" }
const _hoisted_23 = {
  key: 1,
  class: "grey-form-card"
}
const _hoisted_24 = { class: "card-parent" }
const _hoisted_25 = /*#__PURE__*/_createVNode("h6", { class: "small-grey" }, "Site", -1)
const _hoisted_26 = { class: "card-row" }
const _hoisted_27 = { class: "card-label" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Site Name:")
const _hoisted_29 = { class: "card-value" }
const _hoisted_30 = { class: "card-row" }
const _hoisted_31 = { class: "card-label" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Address:")
const _hoisted_33 = { class: "card-value" }
const _hoisted_34 = {
  key: 0,
  class: "card-divider"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_36 = {
  key: 1,
  class: "card-parent"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("h6", { class: "small-grey" }, "Contact Person", -1)
const _hoisted_38 = { class: "card-row" }
const _hoisted_39 = { class: "card-label" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Name:")
const _hoisted_41 = { class: "card-value" }
const _hoisted_42 = { class: "card-row" }
const _hoisted_43 = { class: "card-label" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Email:")
const _hoisted_45 = { class: "card-value" }
const _hoisted_46 = { class: "card-label" }
const _hoisted_47 = { class: "card-value" }
const _hoisted_48 = { class: "card-row" }
const _hoisted_49 = { class: "card-label" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode("Job Title:")
const _hoisted_51 = { class: "card-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditIcon = _resolveComponent("EditIcon")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_StatusRectangle = _resolveComponent("StatusRectangle")
  const _component_WorkOutlineIcon = _resolveComponent("WorkOutlineIcon")
  const _component_EmailIcon = _resolveComponent("EmailIcon")
  const _component_PhoneIcon = _resolveComponent("PhoneIcon")
  const _component_LanguageIcon = _resolveComponent("LanguageIcon")
  const _component_CorporateFareIcon = _resolveComponent("CorporateFareIcon")
  const _component_UserIcon = _resolveComponent("UserIcon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.profile)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", null, [
              _createVNode("h6", null, _toDisplayString(_ctx.profile.first_name) + " " + _toDisplayString(_ctx.profile.last_name), 1)
            ]),
            _createVNode("div", null, [
              (_ctx.hasRole(_ctx.UserRole.SystemAdmin, _ctx.UserRole.SiteAdmin) && _ctx.profile.status !== _ctx.UserStatus.Deactivated)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    class: "edit-button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleAction(_ctx.UserAction.Edit)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_EditIcon)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_dropdown, {
                type: "primary",
                trigger: "click"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.operations, (operation) => {
                        return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                          class: { 'delemiter-after': operation.delemiterAfter },
                          key: operation.action,
                          onClick: ($event: any) => (_ctx.handleAction(operation.action))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(operation.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["class", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, null, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode("h6", _hoisted_5, _toDisplayString(_ctx.formatUserRoles(_ctx.profile.role_ids)), 1),
          _createVNode(_component_StatusRectangle, {
            status: _ctx.profile.status
          }, null, 8, ["status"]),
          _createVNode("div", _hoisted_6, [
            (_ctx.profile.title)
              ? (_openBlock(), _createBlock("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode(_component_WorkOutlineIcon),
                    _hoisted_9
                  ]),
                  _createVNode("div", _hoisted_10, _toDisplayString(_ctx.profile.title), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.profile.email)
              ? (_openBlock(), _createBlock("div", _hoisted_11, [
                  (_ctx.profile.email)
                    ? (_openBlock(), _createBlock("div", _hoisted_12, [
                        _createVNode(_component_EmailIcon),
                        _hoisted_13
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_14, _toDisplayString(_ctx.profile.email), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.profile.country_code || _ctx.profile.phone_number)
              ? (_openBlock(), _createBlock("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode(_component_PhoneIcon),
                    _hoisted_17
                  ]),
                  _createVNode("div", _hoisted_18, _toDisplayString(_ctx.formatPhone(_ctx.profile.country_code, _ctx.profile.phone_number)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.profile.language)
              ? (_openBlock(), _createBlock("div", _hoisted_19, [
                  _createVNode("div", _hoisted_20, [
                    _createVNode(_component_LanguageIcon),
                    _hoisted_21
                  ]),
                  _createVNode("div", _hoisted_22, _toDisplayString(_ctx.userLang), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.site)
      ? (_openBlock(), _createBlock("div", _hoisted_23, [
          _createVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _createVNode(_component_CorporateFareIcon),
                _hoisted_28
              ]),
              _createVNode("div", _hoisted_29, _toDisplayString(_ctx.site.name), 1)
            ]),
            _createVNode("div", _hoisted_30, [
              _createVNode("div", _hoisted_31, [
                _createVNode(_component_EmailIcon),
                _hoisted_32
              ]),
              _createVNode("div", _hoisted_33, _toDisplayString(_ctx.formatAddress(_ctx.site)), 1)
            ])
          ]),
          (_ctx.contact)
            ? (_openBlock(), _createBlock("div", _hoisted_34, [
                _hoisted_35
              ]))
            : _createCommentVNode("", true),
          (_ctx.contact)
            ? (_openBlock(), _createBlock("div", _hoisted_36, [
                _hoisted_37,
                _createVNode("div", _hoisted_38, [
                  _createVNode("div", _hoisted_39, [
                    _createVNode(_component_UserIcon),
                    _hoisted_40
                  ]),
                  _createVNode("div", _hoisted_41, _toDisplayString(_ctx.contact.first_name) + " " + _toDisplayString(_ctx.contact.last_name), 1)
                ]),
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, [
                    _createVNode(_component_EmailIcon),
                    _hoisted_44
                  ]),
                  _createVNode("div", _hoisted_45, _toDisplayString(_ctx.contact.email), 1)
                ]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.contact.phone_numbers, (phone, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "card-row",
                    key: index
                  }, [
                    _createVNode("div", _hoisted_46, [
                      _createVNode(_component_PhoneIcon),
                      _createTextVNode("Phone " + _toDisplayString(index + 1) + ":", 1)
                    ]),
                    _createVNode("div", _hoisted_47, _toDisplayString(_ctx.formatFullPhone(phone)), 1)
                  ]))
                }), 128)),
                _createVNode("div", _hoisted_48, [
                  _createVNode("div", _hoisted_49, [
                    _createVNode(_component_WorkOutlineIcon),
                    _hoisted_50
                  ]),
                  _createVNode("div", _hoisted_51, _toDisplayString(_ctx.contact.title), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}